import React from 'react';
import { Row } from '../../../../atoms/row/Row';
// import { ArrowFull } from '../../../../../../static/icons/arrowFull';
import { Arrow } from '../../../../../../static/icons/arrow';
import { LinkButton } from '../../../../atoms/linkButton/LinkButton';

const PaginationLinks = ({ pages, currentPage, t }) => {
  const totalPages = pages.length;

  const renderPagination = () => {
    const pageNumbers = [];
    const maxVisiblePages = 3;

    const startPage = Math.max(
      currentPage - Math.floor(maxVisiblePages / 2),
      1
    );
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <LinkButton
            key={`paginiation-link-${i}`}
            label={pages[i - 1].title}
            href={pages[i - 1].href}
            variant="transparent"
            size="md"
            className={`rounded-lg ${
              currentPage === i
                ? 'bg-primary-100 text-primary-600'
                : 'bg-transparent text-customGray-500'
            }`}
          />
        );
      }
    } else {
      if (currentPage - Math.floor(maxVisiblePages / 2) > 1) {
        pageNumbers.push(
          <LinkButton
            key="paginiation-link-0"
            label={pages[0].title}
            href={pages[0].href}
            variant="transparent"
            size="md"
            className={`rounded-lg ${
              currentPage === 1
                ? 'bg-primary-100 text-primary-600'
                : 'bg-transparent text-customGray-500'
            }`}
          />
        );

        pageNumbers.push(
          <span
            key="ellipsis-start"
            className="px-3 py-1 rounded bg-transparent cursor-default"
          >
            ...
          </span>
        );
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <LinkButton
            key={`paginiation-link-${i - 1}`}
            label={pages[i - 1].title}
            href={pages[i - 1].href}
            variant="transparent"
            size="md"
            className={`rounded-lg ${
              currentPage === i
                ? 'bg-primary-100 text-primary-600'
                : 'bg-transparent text-customGray-500'
            }`}
          />
        );
      }

      if (currentPage + Math.floor(maxVisiblePages / 2) < totalPages) {
        pageNumbers.push(
          <span
            key="ellipsis-end"
            className="px-3 py-1 rounded bg-transparent cursor-default"
          >
            ...
          </span>
        );

        pageNumbers.push(
          <LinkButton
            key={`paginiation-link-${totalPages - 1}`}
            label={pages[totalPages - 1].title}
            href={pages[totalPages - 1].href}
            variant="transparent"
            size="md"
            className={`rounded-lg ${
              currentPage === totalPages
                ? 'bg-primary-100 text-primary-600'
                : 'bg-transparent text-customGray-500'
            }`}
          />
        );
      }
    }

    return pageNumbers;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-col md:flex-row mt-3 pt-2 w-full gap-3 md:gap-1 items-center justify-between">
      <div className="flex flex-row min-w-28 justify-center w-fit bg-transparent  font-medium items-center gap-3 px-4 py-2 text-clamp-sm !text-customGray-700">
        <LinkButton
          key="paginiation-link-arrow-first"
          href={pages[0].href}
          clickable={currentPage !== 1}
          variant="transparent"
          className={`border border-customGray-300 rounded-lg ${
            currentPage === 1 ? 'cursor-default opacity-50' : 'cursor-pointer'
          }`}
        >
          <Arrow />
          <Arrow />
        </LinkButton>

        <LinkButton
          key="paginiation-link-arrow-left"
          href={pages[currentPage - 2]?.href}
          clickable={currentPage !== 1}
          variant="transparent"
          className={`border border-customGray-300 rounded-lg ${
            currentPage === 1 ? 'cursor-default opacity-50' : 'cursor-pointer'
          }`}
        >
          <Arrow />
        </LinkButton>
      </div>

      <Row>{renderPagination()}</Row>

      <div className="flex flex-rowmin-w-28 justify-center w-fit bg-transparent  font-medium items-center gap-3 px-4 py-2 text-clamp-sm !text-customGray-700">
        <LinkButton
          key="paginiation-link-arrow-last"
          href={pages[currentPage]?.href}
          clickable={currentPage != totalPages}
          variant="transparent"
          className={`border border-customGray-300 rounded-lg ${
            currentPage === 1 ? 'cursor-default opacity-50' : 'cursor-pointer'
          }`}
        >
          <Arrow direction="right" />
        </LinkButton>

        <LinkButton
          key="paginiation-link-arrow-last"
          href={pages[totalPages - 1].href}
          clickable={currentPage != totalPages}
          variant="transparent"
          className={`border border-customGray-300 rounded-lg ${
            currentPage === 1 ? 'cursor-default opacity-50' : 'cursor-pointer'
          }`}
        >
          <Arrow direction="right" />
          <Arrow direction="right" />
        </LinkButton>
      </div>
    </div>
  );
};

export default PaginationLinks;
